import { render } from "./ArchiveBillsModal.vue?vue&type=template&id=79a4d325&scoped=true"
import script from "./ArchiveBillsModal.vue?vue&type=script&lang=js"
export * from "./ArchiveBillsModal.vue?vue&type=script&lang=js"

import "./ArchiveBillsModal.vue?vue&type=style&index=0&id=79a4d325&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a4d325"]])

export default __exports__